import { UrlMatchResult, UrlSegment } from '@angular/router';

/** The page's URL — the plant's default synoptic (its first tab). Every other tab is `/synoptique/<synopticId>`. */
export const SYNOPTIC_ROUTE = '/synoptique';

/** The route param naming a non-default tab. */
export const SYNOPTIC_ID_PARAM = 'synopticId';

/**
 * Matches `synoptique` and `synoptique/<synopticId>` as ONE route, rather than
 * two route entries: Angular reuses a component only within the same route
 * config, so with two entries every switch between the default tab and
 * another would destroy and rebuild the page (resetting the day picker and
 * fit mode). One route also means a tab switch is a param change on that
 * route, which re-runs its `canDeactivate` — the unsaved-changes guard still
 * catches a mid-edit tab switch.
 */
export function synopticRouteMatcher(
  segments: UrlSegment[],
): UrlMatchResult | null {
  if (segments[0]?.path !== SYNOPTIC_ROUTE.slice(1) || segments.length > 2)
    return null;
  const [, idSegment] = segments;
  return {
    consumed: segments,
    posParams: idSegment ? { [SYNOPTIC_ID_PARAM]: idSegment } : {},
  };
}

/** Router commands for a tab: the default one (`null`) has no id segment. */
export function synopticTabCommands(synopticId: string | null): string[] {
  return synopticId === null ? [SYNOPTIC_ROUTE] : [SYNOPTIC_ROUTE, synopticId];
}
